import React from 'react';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { connect } from 'react-redux';
import { withRouter, useLocation } from 'react-router-dom';
import { Modal, Input, Typography, Select } from 'antd';
import {
  getProject,
  getIssues,
  getIssueFields,
  dropDownSearchJiraProjects,
  searchJiraProjects,
  getAllLabelsInTheDomain,
  /* getAllResolutionsInTheDomain, */ getAllUsersInTheDomain,
  getAllStatusesInTheDomain,
} from '../skills_action';
import { cardInfo } from './report_actions';
import TextArea from 'antd/lib/input/TextArea';

const { Text } = Typography;
const { Option } = Select;

const CustomFilter = (props) => {
  const {
    match: {
      params: { wId },
    },
    handleUpdateFieldDefaultsChanges,
    handleCustomFields,
    skills,
    projects,
    setShowUpdateFilterModal,
    showUpdateFilterModal,
  } = props;

  const cardInfoFromStore = useSelector((state) => state.report.cardInfo);
  const cardSkill = useSelector((state) => state.report.template);
  let cardSkillFilter =
    cardSkill &&
    cardSkill.cardInformation &&
    cardSkill.cardInformation.cardInformation &&
    cardSkill.cardInformation.cardInformation.filters;
  const dispatch = useDispatch();
  const [filters, setFilters] = useState(
    cardInfoFromStore && cardInfoFromStore.filters
  );

  //   console.log(filters);

  const handleJql = (data) => {
    let jql;
    const addDoubleQoutes = (arr) => {
      return arr && arr.length > 0 ? arr.map((e) => `"${e}"`) : [];
    };

    const issue = addDoubleQoutes(data.selectedIssues).join();
    const project = addDoubleQoutes(data.selectedProjects).join();
    const status = addDoubleQoutes(data.status).join();
    const reporter = addDoubleQoutes(data.reporter).join();
    const assignee = addDoubleQoutes(data.assignee).join();
    const label = addDoubleQoutes(data.labels).join();

    let tempJql = ' ';
    let fieldsArr = [];

    let reporters =
      data && data.reporter && data.reporter.length !== 0
        ? `reporter in (${reporter})`
        : ' ';
    let assignees =
      data && data.assignee && data.assignee.length !== 0
        ? `assignee in (${assignee})`
        : ' ';
    let issueTypes =
      data && data.selectedIssues && data.selectedIssues.length !== 0
        ? `issuetype in (${issue})`
        : ' ';
    let projects =
      data && data.selectedProjects && data.selectedProjects.length !== 0
        ? `project in (${project})`
        : ' ';
    let statuses =
      data && data.status && data.status.length !== 0
        ? `status in (${status})`
        : ' ';
    let labels =
      data && data.labels && data.labels.length !== 0
        ? `labels in (${label})`
        : ' ';

    fieldsArr.push(
      reporters,
      assignees,
      issueTypes,
      projects,
      statuses,
      labels
    );

    let jqlArr = [];

    fieldsArr.forEach((fields) => {
      // console.log(fields)
      if (fields.includes('reporter')) {
        jqlArr.push(reporters);
      }
      if (fields.includes('assignee')) {
        jqlArr.push(assignees);
      }
      if (fields.includes('issuetype')) {
        jqlArr.push(issueTypes);
      }
      if (fields.includes('project')) {
        jqlArr.push(projects);
      }
      if (fields.includes('status')) {
        jqlArr.push(statuses);
      }
      if (fields.includes('label')) {
        jqlArr.push(labels);
      }
      // if(fields.includes(jql)){
      //   jqlArr.push(jql)
      // }
    });

    jql = jqlArr.join(' AND ');
    // console.log(jql);
    return jql;
  };

  const jiraSkill = skills.find((skill) => skill.key === 'jira');

  const [labels, set_labels] = useState([]);
  const [resolutions, set_resolutions] = useState([]);
  const [jiraUsers, set_jiraUsers] = useState([]);
  const [statuses, set_statuses] = useState([]);
  const [selectedLabels, set_selectedLabels] = useState([]);
  const [selectedResolution, set_selectedResolution] = useState(null);
  const [selectedAssignee, set_selectedAssignee] = useState([]);
  const [selectedStatus, set_selectedStatus] = useState([]);
  const [selectedReporter, set_selectedReporter] = useState([]);

  const [selectedProjects, setSelectedProjects] = useState([]);
  const [selectedIssues, setSelectedIssues] = useState([]);
  const [allIssues, setAllIssues] = useState([]);
  const [generatedJql, setGeneratedJql] = useState('');

  useEffect(() => {
    getAllLabelsInTheDomain(wId).then((res) => {
      if (res.success) set_labels(res.labels);
    });
    // getAllResolutionsInTheDomain(wId).then((res) => {
    //   if (res.success) set_resolutions(res.resolutions);
    // });
    getAllUsersInTheDomain(wId).then((res) => {
      if (res.success) set_jiraUsers(res.jiraUsers);
    });

    getAllStatusesInTheDomain(wId).then((res) => {
      // if (res.success) set_statuses(res.statuses);
      if (res.success) filterStatuses(res.statuses);
    });

    getIssueFields(wId).then((res) => {
      const uniqueIssueTypes = [];
      if (res.data.success) {
        const unique = res.data.items.filter((issueType) => {
          const isDuplicate = uniqueIssueTypes.includes(issueType.name);
          if (!isDuplicate) {
            uniqueIssueTypes.push(issueType.name);
            return true;
          }
          return false;
        });
        setAllIssues(unique);
      }
    });
    updateState();

    return () => {
      // set_selectedLabels([]);
      // set_selectedReporter(forCommands?[]:null);
      // set_selectedAssignee(forCommands?[]:null);
      // set_selectedStatus(forCommands?[]:null);
      // setSelectedProjects([]);
      // setSelectedIssues([]);
      // labels  = []
      // selectedAssignee = []
      // selectedProjects = []
      // selectedStatus = []
    };
  }, []);

  useEffect(() => {
    updateState();
  }, []);
  let jql;
  useEffect(() => {
    let data = {};
    if (selectedLabels && selectedLabels.length > 0)
      data.labels = selectedLabels;
    if (selectedResolution) data.resolution = selectedResolution;
    if (selectedReporter) data.reporter = selectedReporter;
    if (selectedAssignee) data.assignee = selectedAssignee;
    if (selectedStatus) data.status = selectedStatus;
    if (selectedProjects) data.selectedProjects = selectedProjects;
    if (selectedIssues) data.selectedIssues = selectedIssues;
    jql = handleJql(data);
    setGeneratedJql(jql);
    setFilters(data);
    handleCustomFields(data, jql);
  }, [
    selectedLabels,
    selectedResolution,
    selectedAssignee,
    selectedReporter,
    selectedStatus,
    selectedProjects,
    selectedIssues,
  ]);
  // console.log(selectedLabels, selectedResolution, selectedAssignee, selectedReporter, selectedStatus, selectedProjects, selectedIssues)
  // console.log(selectedCommandForUpdate)

  const updateState = () => {
    if (filters) {
      filters.labels && filters.labels.length > 0
        ? set_selectedLabels(filters.labels)
        : set_selectedLabels([]);

      filters.reporter && filters.reporter.length > 0
        ? set_selectedReporter(filters.reporter)
        : set_selectedReporter([]);

      filters.assignee && filters.assignee.length > 0
        ? set_selectedAssignee(filters.assignee)
        : set_selectedAssignee([]);

      filters.status && filters.status.length > 0
        ? set_selectedStatus(filters.status)
        : set_selectedStatus([]);

      filters.selectedProjects && filters.selectedProjects.length > 0
        ? setSelectedProjects(filters.selectedProjects)
        : setSelectedProjects([]);

      filters.selectedIssues && filters.selectedIssues.length > 0
        ? setSelectedIssues(filters.selectedIssues)
        : setSelectedIssues([]);
    }
  };
  const filterStatuses = (statusesData) => {
    let statuses = [];
    statusesData.forEach((status) => {
      if (status.name !== 'Backlog' && !statuses.includes(status.name))
        statuses.push(status.name);
    });
    set_statuses(statuses);
  };

  const onSearch = (val) => {
    let timeout = 0;

    if (
      jiraSkill &&
      jiraSkill.skill_metadata &&
      jiraSkill.skill_metadata.metadata &&
      (jiraSkill.skill_metadata.metadata.server_type === 'jira_cloud_oauth' ||
        jiraSkill.skill_metadata.metadata.server_type === 'jira_cloud')
    ) {
      let query = `query=${val || ''}`;

      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        props.dropDownSearchJiraProjects(wId, `?query=${query}`);
      }, 300);
    }
  };

  const handleChange = ({ type, value, options }) => {
    let temp;
    temp = options.map((o) => o.project);
    temp = temp.filter(function (element) {
      return element !== undefined;
    });
    setSelectedProjects(value);
  };

  let children = projects
    .filter(
      (proj) =>
        proj.projectTypeKey === 'software' ||
        proj.projectTypeKey === 'business' ||
        proj.projectTypeKey === 'service_desk'
    )
    .map((d) => {
      // console.log(' DDDDDDDDDDDDDDDDDDDDDDD is  here \n', d)
      return (
        <Option
          key={d.key || d.projectKey}
          value={d.id || d.projectId}
          name={d.name || d.projectName}
          project={d}
        >
          {`${d.name || d.projectName} ${`(${d.key || d.projectKey})`}`}
        </Option>
      );
    });
  children = children.filter((child) => {
    return child;
  });

  return (
    <Modal
      title={'Custom Filter'}
      visible={showUpdateFilterModal}
      onOk={() => {
        setShowUpdateFilterModal(false);
        dispatch(
          cardInfo({
            ...cardInfoFromStore,
            jql: generatedJql,
            filters: filters,
          })
        );
      }}
      okText='Save'
      onCancel={() => {
        setShowUpdateFilterModal(false);
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          paddingRight: 16,
        }}
      >
        <div
          style={{
            marginBottom: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Text type='secondary' strong>
            Choose project(s)
          </Text>
          <Select
            // style={{ width: "81%" }}
            mode='multiple'
            showSearch
            autoClearSearchValue
            placeholder='Select projects'
            onSearch={(val) => onSearch(val)}
            onChange={(value, options) =>
              handleChange({ type: 'select', value, options })
            }
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            value={selectedProjects}
            // disabled={disabled}
            allowClear
            loading={projects && projects.length === 0}
          >
            {children}
          </Select>
        </div>

        <div
          style={{
            marginBottom: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Text type='secondary' strong>
            Choose issue type(s)
          </Text>
          <Select
            // style={{ width: 220 }}
            placeholder='Choose issue type(s)'
            mode='multiple'
            // defaultValue={}
            allowClear
            onChange={(value) => setSelectedIssues(value ? value : null)}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            value={selectedIssues ? selectedIssues : null}
          >
            {allIssues &&
              allIssues.map((issue, index) => (
                <Option key={issue.name} value={issue.name}>
                  {issue.projectName
                    ? `${issue.name} (${issue.projectName})`
                    : issue.name}
                </Option>
              ))}
          </Select>
        </div>

        <div
          style={{
            marginBottom: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Text type='secondary' strong>
            Set status
          </Text>
          <Select
            mode={'multiple'}
            allowClear
            placeholder='Set status'
            loading={statuses.length === 0}
            onChange={(value) => set_selectedStatus(value)}
            value={selectedStatus}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            showSearch
          >
            {statuses.map((status) => (
              <Option key={status} value={status}>
                {status}
              </Option>
            ))}
          </Select>
        </div>
        <div
          style={{
            marginBottom: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Text type='secondary' strong>
            Assignee
          </Text>
          <Select
            allowClear
            mode={'multiple'}
            placeholder='Set assignee'
            loading={jiraUsers.length === 0}
            value={
              selectedAssignee
                ? selectedAssignee.map((assignee) => assignee)
                : []
            }
            onChange={(value, data) => {
              set_selectedAssignee(value ? value : null);
            }}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            showSearch
          >
            {jiraUsers.map((user) => (
              <Option
                key={user.accountId || user.name}
                value={user.accountId || user.name}
                assignee={user}
              >
                {user.displayName}
              </Option>
            ))}
          </Select>
        </div>
        <div
          style={{
            // marginRight: 16,
            marginBottom: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Text type='secondary' strong>
            Reporter
          </Text>
          <Select
            allowClear
            placeholder='Set reporter'
            mode={'multiple'}
            loading={jiraUsers.length === 0}
            value={
              selectedReporter
                ? selectedReporter.map((reporter) => reporter)
                : []
            }
            onChange={(value, data) => {
              set_selectedReporter(value ? value : []);
            }}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            showSearch
          >
            {jiraUsers.map((user) => (
              <Option
                key={user.accountId || user.name}
                value={user.accountId || user.name}
                reporter={user}
              >
                {user.displayName}
              </Option>
            ))}
          </Select>
        </div>

        <div
          style={{
            marginBottom: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Text type='secondary' strong>
            Label(s)
          </Text>
          <Select
            allowClear
            placeholder='Set Label(s)'
            mode='multiple'
            loading={labels && labels.length === 0}
            onChange={(value) => set_selectedLabels(value)}
            value={selectedLabels}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            showSearch
          >
            {labels &&
              labels.map((label) => (
                <Option key={label} value={label}>
                  {label}
                </Option>
              ))}
          </Select>
        </div>
      </div>
      Generated JQL
      <TextArea readOnly value={generatedJql} />
    </Modal>
  );
};
const mapStateToProps = (state) => {
  return {
    isAdmin: state.common_reducer.isAdmin,
    projects: state.skills.projects,
    issues: state.skills.issues,
    skills: state.skills.skills,
    team: state.skills.team,

    user_now: state.common_reducer.user,
    currentSkill: state.skills.currentSkill,
    jiraSkill: state.skills.skills
      ? state.skills.skills.find((skill) => skill.key === 'jira')
      : null,
  };
};
// export default withRouter(JiraCommonIssueFields);

/*  return (
    <Modal
      title={'Custom Filter'}
      visible={showUpdateFilterModal}
      onOk={() => {
        setShowUpdateFilterModal(false);
      }}
      okText='Save'
      onCancel={() => {}}>
     
    </Modal>
  ); */

export default withRouter(
  connect(mapStateToProps, {
    getProject,
    getIssues,
    dropDownSearchJiraProjects,
    searchJiraProjects,
  })(CustomFilter)
);
